module.exports = __webpack_public_path__ + "img/backhand_index_pointing_up.fe8817dd.gif";